<template>
	<div>
	</div>
</template>

<script>
import Vue from 'vue'
import Confirm from './Confirm'
// const key = () => `${Date.now()}-${Math.random()}`
// import Prompt from './Prompt'
// import VDialog from './Dialog'
export default {
	data () {
		return {
			items: []
		}
	},
	methods: {
		confirm (message, options = {}) {
			return new Promise((resolve, reject) => {
				const dialog = new Vue({
					methods: {
						closeHandler (fn, arg) {
							return function () {
								fn(arg)
								dialog.$destroy()
								dialog.$el.remove()
							}
						}
					},
					render (h) {
						return h(Confirm, {
							props: {
								show: true,
								textMessage: message
							},
							on: {
								confirm: this.closeHandler(resolve),
								cancel: this.closeHandler(reject, new Error('canceled'))
							}
						})
					}
				}).$mount()
				document.body.appendChild(dialog.$el)
			})
		}
	}
}
</script>
<style>
.modal.show {
	display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/dialog/dialog.vue